import { PaymentMethod } from './payment-methods';

// Default
export interface PaymentMethodsResponse {
    paymentMethods: PaymentMethod[];
}

// Preassigned
export interface PaymentMethodsPreassignedResponse {
    paymentMethods: PaymentMethodsPreassignedResponseMethod[];
}

export interface PaymentMethodsPreassignedResponseMethod extends PaymentMethod {
    paymentMethodSettings: PaymentMethodsPreassignedResponseMethodData[];
}

export interface PaymentMethodsPreassignedResponseMethodData {
    code: PaymentMethodsSettingsResponseCodes;
    value: string;
}

export enum PaymentMethodsSettingsResponseCodes {
    DAILY_LIMIT = 'DAILY_LIMIT',
    THRESHOLD_ORDER_AMOUNT = 'THRESHOLD_ORDER_AMOUNT',
    UP_TO_THRESHOLD_COMMISSION_RATE = 'UP_TO_THRESHOLD_COMMISSION_RATE',
    EQUAL_OR_ABOVE_THRESHOLD_COMMISSION_RATE = 'EQUAL_OR_ABOVE_THRESHOLD_COMMISSION_RATE'
}
